import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=31aa68d8&"
import script from "./ModalRoot.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ModalRoot.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports